import { Stack } from '@mui/material';
import { ComponentSharedTwoColumnSection } from '@peerless/data-access/strapi';
import { SectionHeader } from './SectionHeader';
import { withSectionLayout } from './SectionLayout';
import { CallToActionSection } from './CallToActionSection';

interface Props {
  data: ComponentSharedTwoColumnSection;
}

function _TwoColumnSection({ data }: Props) {
  const col1Width = data.column1Width ? `${data.column1Width.slice(-2)}%` : '50%';
  const col2Width = data.column2Width ? `${data.column2Width.slice(-2)}%` : '50%';
  return (
    <Stack gap={4}>
      <SectionHeader {...data.sectionHeader} />
      <Stack flexWrap={'wrap'} sx={{ flexDirection: { xs: 'column', md: 'row' } }}>
        <Stack
          sx={{
            width: { xs: '100%', md: col1Width },
            paddingRight: { xs: 0, md: 2 },
          }}
        >
          <div dangerouslySetInnerHTML={{ __html: data.column1 }} />
        </Stack>
        <Stack
          sx={{
            width: { xs: '100%', md: col2Width },
            paddingLeft: { xs: 0, md: 2 },
          }}
        >
          <div dangerouslySetInnerHTML={{ __html: data.column2 }} />
        </Stack>
      </Stack>
      <CallToActionSection callToAction={data?.callToAction} />
    </Stack>
  );
}

export const TwoColumnSection = withSectionLayout(_TwoColumnSection);
